import request from '@/utils/request'


// 查询打卡记录列表
export function listRecord(query) {
  return request({
    url: '/check/check-record/list',
    method: 'get',
    params: query
  })
}

// 查询打卡记录分页
export function pageRecord(query) {
  return request({
    url: '/check/check-record/page',
    method: 'get',
    params: query
  })
}

// 查询打卡记录详细
export function getRecord(data) {
  return request({
    url: '/check/check-record/detail',
    method: 'get',
    params: data
  })
}

// 新增打卡记录
export function addRecord(data) {
  return request({
    url: '/check/check-record/add',
    method: 'post',
    data: data
  })
}

// 修改打卡记录
export function updateRecord(data) {
  return request({
    url: '/check/check-record/edit',
    method: 'post',
    data: data
  })
}

// 删除打卡记录
export function delRecord(data) {
  return request({
    url: '/check/check-record/delete',
    method: 'post',
    data: data
  })
}
